import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoginComponent } from "./pages/login/login.component";
import { AuthGuard } from "./auth/auth.guard";
import { FormDeactivateGuard } from "./common/guards/form-deactivate.guard";
import { UnderConstructionComponent } from "./pages/common/under-construction/under-construction.component";
import { AccessDeniedComponent } from "./pages/common/access-denied/access-denied.component";
import { SubMenuLayoutComponent } from "./common/layouts/sub-menu-layout/sub-menu-layout.component";
import { SystemComponent } from "./pages/system/system/system.component";
import { DepartmentComponent } from "./pages/system/department/department.component";
import { DepartmentEditComponent } from "./pages/system/department/department-edit/department-edit.component";
import { JobPositionComponent } from "./pages/system/job-position/job-position.component";
import { JobPositionEditComponent } from "./pages/system/job-position/job-position-edit/job-position-edit.component";
import { EmployeeTypeComponent } from "./pages/system/employee-type/employee-type.component";
import { EmployeeTypeEditComponent } from "./pages/system/employee-type/employee-type-edit/employee-type-edit.component";
import { EmployeeJobTitleComponent } from "./pages/system/employee-job-title/employee-job-title/employee-job-title.component";
import { EmployeeJobTitleEditComponent } from "./pages/system/employee-job-title/employee-job-title-edit/employee-job-title-edit.component";
import { TaskComponent } from "./pages/system/task/task.component";
import { TaskEditComponent } from "./pages/system/task/task-edit/task-edit.component";
import { ShiftComponent } from "./pages/system/shift/shift.component";
import { ShiftEditComponent } from "./pages/system/shift/shift-edit/shift-edit.component";
import { LeaveTypeComponent } from "./pages/system/leave-type/leave-type.component";
import { LeaveTypeEditComponent } from "./pages/system/leave-type/leave-type-edit/leave-type-edit.component";
import { ReasonComponent } from "./pages/system/reason/reason.component";
import { ReasonEditComponent } from "./pages/system/reason/reason-edit/reason-edit.component";
import { SystemSettingsComponent } from "./pages/system/settings/system-settings.component";
import { EmployeeComponent } from './pages/employee/employee.component';
import { EmployeeEditComponent } from './pages/employee/employee-edit/employee-edit.component';
import { RosterComponent } from './pages/roster/roster.component';
import { RosterListComponent } from './pages/roster/roster-list/roster-list.component';
const routes: Routes = [

  { path: "", redirectTo: "login", pathMatch: "full" },
  { component: LoginComponent, path: "login" },

  {
    path: "system",
    component: SubMenuLayoutComponent,
    data: { menuType: 'system' },
    canActivateChild: [AuthGuard],
    children: [
      {
        path: "",
        redirectTo: "job-position",
        pathMatch: "full",
      },
      {
        path: "department-edit/:id",
        component: DepartmentEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "department",
        component: DepartmentComponent,
      },
      {
        path: "job-position-edit/:id",
        component: JobPositionEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "job-position",
        component: JobPositionComponent,
      },
      {
        path: "employee-type-edit/:id",
        component: EmployeeTypeEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "employee-type",
        component: EmployeeTypeComponent,
      },
      {
        path: "job-title-edit/:id",
        component: EmployeeJobTitleEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "job-title",
        component: EmployeeJobTitleComponent,
      },
      {
        path: "task-edit/:id",
        component: TaskEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "task",
        component: TaskComponent,
      },
      {
        path: "shift-edit/:id",
        component: ShiftEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "shift",
        component: ShiftComponent,
      },
      {
        path: "leave-type-edit/:id",
        component: LeaveTypeEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "leave-type",
        component: LeaveTypeComponent,
      },
      {
        path: "reason-edit/:id",
        component: ReasonEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
      {
        path: "reason",
        component: ReasonComponent,
      },
      {
        path: "settings",
        component: SystemSettingsComponent,
        canDeactivate: [FormDeactivateGuard]
      }
    ]
  },
  {
    path: "employee",
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        component: EmployeeComponent,
      },
      {
        path: "employee-edit/:id",
        component: EmployeeEditComponent,
        canDeactivate: [FormDeactivateGuard],
      },
    ]
  },
  {
    path: "roster",
    canActivate: [AuthGuard],
    children: [
      { path: "", component: RosterListComponent },
      {
        path: "planner",
        component: RosterComponent,
        canDeactivate: [FormDeactivateGuard]
      },
      {
        path: "viewer",
        component: RosterComponent,
        canDeactivate: [FormDeactivateGuard]
      }
    ]
  },
  {
    component: AccessDeniedComponent,
    path: "access-denied",
  },
  {
    path: "**",
    redirectTo: "access-denied"
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [FormDeactivateGuard],
})
export class AppRoutingModule { }
